import { render } from "./AdminEnded.vue?vue&type=template&id=5a9241c4"
import script from "./AdminEnded.vue?vue&type=script&lang=js"
export * from "./AdminEnded.vue?vue&type=script&lang=js"
script.render = render

export default script